import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { MemberService } from './../../../../../../../rest/api/member.service';
import { AuthService } from './../../../../../../../services/auth.service';

@Component({
  selector: 'app-delete-snapshot-modal',
  templateUrl: './delete-snapshot-modal.component.html',
  styleUrls: ['./delete-snapshot-modal.component.scss']
})
export class DeleteSnapshotModalComponent implements OnInit, OnChanges {

  @Input() singleSnapshot;
  @Input() hotspotType;
  @Output() modalCloseEmit = new EventEmitter();
  @Output() modalCloseDeleteSnapshotEmit = new EventEmitter();
  isSubmitted = false;
  accessToken: any;
  deleteError;
  deleteSuccess;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleSnapshot && changes.singleSnapshot.currentValue) {
      this.resetErrorValues();
    }
  }

  deleteSnapshots(singleSnapshot) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteSnapshotsEmit(singleSnapshot);
  }

  deleteSnapshotsEmit(singleSnapshot) {
    this.deleteError = undefined;
    this.memberService.deleteSnapshots({
      Authorization: this.accessToken,
      id: singleSnapshot.uuid
    }).subscribe((response: any) => {
      this.deleteSuccess = 'Snapshot was successfully deleted.';
      setTimeout(() => {
        this.modalCloseEmit.emit(singleSnapshot);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteError = err.error.error;
      } else {
        this.deleteError = 'There was error while deleting snapshot.';
      }
    });

  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

  onClickOutside(event: any) {
    if (event && event.value === true) {
      this.modalCloseDeleteSnapshotEmit.emit(undefined);
    } else {
      console.log('clicked inside');
    }
  }
}
